import { render, staticRenderFns } from "./BaseHeader.vue?vue&type=template&id=a91f8024&scoped=true"
import script from "./BaseHeader.vue?vue&type=script&lang=js"
export * from "./BaseHeader.vue?vue&type=script&lang=js"
import style0 from "./BaseHeader.vue?vue&type=style&index=0&id=a91f8024&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91f8024",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a91f8024')) {
      api.createRecord('a91f8024', component.options)
    } else {
      api.reload('a91f8024', component.options)
    }
    module.hot.accept("./BaseHeader.vue?vue&type=template&id=a91f8024&scoped=true", function () {
      api.rerender('a91f8024', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseHeader.vue"
export default component.exports